"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromocodeConditionValuesDto = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const promocode_product_in_cart_condition_values_dto_1 = require("./promocode-product-in-cart-condition-values.dto");
const promocode_quantity_and_netto_total_greater_condition_values_dto_1 = require("./promocode-quantity-and-netto-total-greater-condition-values.dto");
class PromocodeConditionValuesDto {
}
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], PromocodeConditionValuesDto.prototype, "SUBTOTAL_GREATER", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => promocode_product_in_cart_condition_values_dto_1.PromocodeProductInCartConditionValuesDto),
    __metadata("design:type", promocode_product_in_cart_condition_values_dto_1.PromocodeProductInCartConditionValuesDto)
], PromocodeConditionValuesDto.prototype, "PRODUCTS_IN_CART", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => promocode_quantity_and_netto_total_greater_condition_values_dto_1.PromocodeQuantityAndNettoTotalGreaterConditionValuesDto),
    __metadata("design:type", promocode_quantity_and_netto_total_greater_condition_values_dto_1.PromocodeQuantityAndNettoTotalGreaterConditionValuesDto)
], PromocodeConditionValuesDto.prototype, "QUANTITY_AND_NETTO_TOTAL_GREATER", void 0);
exports.PromocodeConditionValuesDto = PromocodeConditionValuesDto;
//# sourceMappingURL=promocode-condition-values.dto.js.map